<div class="inside-help">
  <!--
	<div data-collapse-system="">
		<div data-collapse="" class="collapse__wrapper">
			<a data-collapse-trigger="" data-collapse-system-trigger="" href="#" role="button" title="{{ 'helps.aa-help' | translate }}" aria-expanded="false" aria-controls="collapse__help-content" class="collapse__trigger mb-1">
				<span class="text-small">{{ 'helps.button' | translate }}</span>
			</a>
			<div data-collapse-content="" class="collapse__content"  id="collapse__help-content">
        <div data-collapse-inner="">
					<p class="text-small" [innerHTML]="helpText"></p>
				</div>
			</div>
		</div>
	</div>
	-->
  <div data-collapse="" class="collapse">
    <a data-collapse-trigger="" href="#" role="button" title="{{ 'helps.aa-help' | translate }}" aria-expanded="false" aria-controls="collapse__help-content" class="collapse__trigger mb-1">
      <span class="text-small">{{ 'helps.button' | translate }}</span>
    </a>
    <div data-collapse-content="" class="collapse__content" id="collapse__help-content">
      <div data-collapse-inner="">
        <p class="text-small" [innerHTML]="helpText"></p>
      </div>
    </div>
  </div>

</div>
